import { fbDB } from "../config/firebase";
import { QUIZ3_DATA_WATCH, QUIZ3_DATA_UPDATE, QUIZ3_META_WATCH } from "./types";

export const quiz3DataWatch = () => async dispatch => {
  fbDB.ref(`/activities/quizzes/data/quiz3`).on("value", snapshot => {
    return dispatch({
      type: QUIZ3_DATA_WATCH,
      payload: {
        data: snapshot.val()
      }
    });
  });
};

export const quiz3DataUpdate = (idx, data) => async dispatch => {
  fbDB
    .ref(`/activities/quizzes/data/quiz3/${idx}`)
    .update({
      ...data
    })
    .then(() => {
      return dispatch({
        type: QUIZ3_DATA_UPDATE,
        payload: null
      });
    })
    .catch(err => {
      console.log(err);
    });
};

export const quiz3MetaWatch = () => async dispatch => {
  fbDB.ref(`/activities/quizzes/meta/quiz3`).on("value", snapshot => {
    return dispatch({
      type: QUIZ3_META_WATCH,
      payload: {
        meta: snapshot.val()
      }
    });
  });
};
